<template>
  <div id="goods-item">
    <template v-if="hGoodsType.includes(goodsType)">
      <div class="goods-item-hgoods" @click="showProduct">
        <div class="goods-image">
          <div v-if="product.IsOutBusinessScope" class="overlay-text text1">
            {{ lang.Goods.Disabled_OverStep }}
          </div>
          <div
            v-else-if="product.IsSoldOut && fromPage == 'MyCollection'"
            class="overlay-text text"
          >
            已下架
          </div>
          <div
            v-else-if="
              (!product.Stock || product.Stock <= 0) &&
                !product.IsSoldOut &&
                fromPage != 'isArriving'
            "
            class="overlay-text text"
          >
            {{ lang.Goods.Disabled_Undercarriage }}
          </div>

          <img v-lazy="_getPic(product.img, true)">
        </div>
        <div class="goods-content">
          <div class="goods-name flex-row align-center">
            <!-- 医保标签标签 -->
            <div
              v-for="properties in product.CommodityListProperties"
              v-if="properties.AttributeName == '医保类型'"
              :key="properties.Id"
              style="margin-right: 4px; font-size: 0;"
            >
              <img
                v-if="properties.Value == 1"
                src="@/assets/goods/class_a.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 2"
                src="@/assets/goods/class_b.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 3"
                src="@/assets/goods/yibao.png"
                width="28px"
                height="16px"
              >
            </div>
            <img
              v-if="
                product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
              "
              src="@/assets/goods/new.png"
              style="margin-right: 4px; width: 30px;"
            >
            <!-- 商品标签 -->
            <img
              v-if="product.GoodsTags.length"
              :src="product.GoodsTags[0].Img"
              style="margin-right: 2px; width: 32px; height: 16px;"
            >
            <div
              :class="
                `title van-ellipsis ${
                  product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
                    ? 'new-width'
                    : 'width'
                }`
              "
            >
              {{ product.name }}
            </div>
          </div>
          <div
            class="goods-size"
            :style="{
              paddingBottom:
                !product.IsCoupon &&
                !product.IsFullReduction &&
                !product.IsFullGift &&
                !product.IsBuyAndGet &&
                !product.IsReturnableCoupon
                  ? '0.1rem'
                  : '0'
            }"
          >
            {{ `规格：${product.Specifications}` }}
          </div>
          <div class="goods-size">
            <div
              v-for="properties in product.CommodityListProperties"
              :key="properties.Id"
              class="goods-exp"
            >
              <!-- <van-tag plain :color="`${color[index % 4]}`">{{ properties.Abbreviation}}</van-tag> -->
              <span v-if="properties.AttributeName == '效期优于'" class="text van-ellipsis">
                {{
                  properties.Abbreviation == '效'
                    ? '效期优于：' + properties.Value
                    : properties.Value
                }}
              </span>
            </div>
          </div>
          <div class="goods-activity-label flex-row">
            <div
              v-if="
                product.IsCoupon ||
                  product.IsFullReduction ||
                  product.IsFullGift ||
                  product.IsBuyAndGet ||
                  product.IsReturnableCoupon
              "
              class="flex"
              @click.stop="activeMore"
            >
              <div v-if="product.IsCoupon" class="tag">领券</div>
              <div v-if="product.IsFullReduction" class="tag">满减</div>
              <div v-if="product.IsFullGift" class="tag">满赠</div>
              <div v-if="product.IsBuyAndGet" class="tag">买赠</div>
              <div v-if="product.IsReturnableCoupon" class="tag">返券</div>
            </div>
          </div>
          <div
            v-if="getProductLabType(product).length || cusOtherInfo.IsShowPrice"
            class="goods-price-panel flex-row"
            style="min-height: 50px;"
          >
            <div style="width: 100%;">
              <div class="goods-price">
                <div
                  v-html="
                    _showProductPrice(
                      product.PriceActivity,
                      product.PriceLimit,
                      fromPage == 'isArriving' || fromPage == 'newProduct'
                    )
                  "
                />
              </div>
              <div class="goods-price-calc">
                <div v-if="product.RetailPrice && product.RetailPrice != 0">
                  <span>{{ lang.Goods.RetailPrice
                  }}{{
                    `${lang.Basic.Price}${Number(product.RetailPrice).toFixed(
                      2
                    )}`
                  }}</span>
                  |
                  <span>
                    {{ lang.Goods.Profit
                    }}{{
                      _showProductProfit(
                        product.RetailPrice,
                        _getProductPrice(
                          product.PriceActivity,
                          product.PriceLimit
                        )
                      ) + '%'
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="goods-price-panel" style="min-height: 50px;">
            {{ cusOtherInfo.NoPriceTitle }}
          </div>

          <div
            v-if="getProductLabType(product).length || cusOtherInfo.IsShowPrice"
            class="goods-price-panel"
            style="margin-top: 10px;"
            @click.stop=""
          >
            <AddCartButton
              :product="product"
              :from-page="goodsType"
            />
          </div>
          <!-- <div v-if="product.IsOutBusinessScope">
						<van-button @click.stop="goConsummate(product.BusinessScope)" class="WanShaBtn" type="info">去完善</van-button>
					</div> -->
        </div>
      </div>
    </template>
    <template v-else-if="lGoodsType.includes(goodsType)">
      <div class="goods-item-lgoods" @click="showProduct">
        <div class="goods-image">
          <div v-if="product.IsOutBusinessScope" class="overlay-text text1">
            {{ lang.Goods.Disabled_OverStep }}
          </div>
          <div
            v-else-if="product.IsSoldOut && fromPage == 'MyCollection'"
            class="overlay-text text"
          >
            已下架
          </div>
          <div
            v-else-if="
              (!product.Stock || parseInt(product.Stock) <= 0) &&
                !product.IsSoldOut &&
                fromPage != 'isArriving'
            "
            class="overlay-text text"
          >
            {{ lang.Goods.Disabled_Undercarriage }}
          </div>

          <img v-lazy="_getPic(product.img, true)">
          <div
            v-if="product.NewProductTime"
            :class="
              `${
                product.NewProductTime
                  ? 'goods-activity-new'
                  : product.EstimatedTime
                    ? 'goods-activity-soon'
                    : ''
              } flex-row`
            "
          >
            <div class="text">仅剩{{ firstTime[3] }}天</div>
            <div class="text">
              <span class="span">{{ firstTime[0] }}</span>
              <span style="text-align: center;">时</span>
              <span class="span">{{ firstTime[1] }}</span>
              <span style="text-align: center;">分</span>
            </div>
          </div>
        </div>
        <div class="goods-content">
          <div
            :class="
              `goods-name flex-row ${
                product.NewProductTime &&
                moment().isBefore(moment(product.NewProductTime))
                  ? 'new'
                  : ''
              }`
            "
          >
            <img
              v-if="
                product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
              "
              src="@/assets/goods/new.png"
              style="margin-right: 4px; width: 30px;"
            >
            <!-- 医保标签标签 -->
            <div
              v-for="properties in product.CommodityListProperties"
              v-if="properties.AttributeName == '医保类型'"
              :key="properties.Id"
              style="margin-right: 4px; font-size: 0;"
            >
              <img
                v-if="properties.Value == 1"
                src="@/assets/goods/class_a.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 2"
                src="@/assets/goods/class_b.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 3"
                src="@/assets/goods/yibao.png"
                width="28px"
                height="16px"
              >
            </div>
            <!-- 商品标签 -->
            <img
              v-if="product.GoodsTags.length"
              :src="product.GoodsTags[0].Img"
              style="width: 32px; height: 16px;"
            >
            <div
              :class="
                `title van-ellipsis ${
                  product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
                    ? 'new-width'
                    : 'width'
                }`
              "
            >
              {{ product.name }}
            </div>
          </div>
          <div
            class="goods-size"
            :style="{
              paddingBottom:
                !product.IsCoupon &&
                !product.IsFullReduction &&
                !product.IsFullGift &&
                !product.IsBuyAndGet &&
                !product.IsReturnableCoupon
                  ? '0'
                  : '0'
            }"
          >
            <div class="goods-exp van-ellipsis">
              <span>{{ `规格：${product.Specifications}` }}</span>
            </div>
          </div>
          <div class="goods-size">
            <div
              v-for="properties in product.CommodityListProperties"
              :key="properties.Id"
              class="goods-exp van-ellipsis"
            >
              <span
                v-if="
                  properties.AttributeName == '效期优于'
                "
              >{{
                properties.Abbreviation == '效'
                  ? '效期优于：' + properties.Value
                  : properties.Value
              }}</span>
            </div>
          </div>
          <div class="goods-activity-label flex-row">
            <div
              v-if="
                product.IsCoupon ||
                  product.IsFullReduction ||
                  product.IsFullGift ||
                  product.IsBuyAndGet ||
                  product.IsReturnableCoupon
              "
              class="flex"
              @click.stop="activeMore"
            >
              <div v-if="product.IsCoupon" class="tag">领券</div>
              <div v-if="product.IsFullReduction" class="tag">满减</div>
              <div v-if="product.IsFullGift" class="tag">满赠</div>
              <div v-if="product.IsBuyAndGet" class="tag">买赠</div>
              <div v-if="product.IsReturnableCoupon" class="tag">返券</div>
            </div>
          </div>
          <div
            v-if="product.EstimatedTime"
            class="goods-activity-panel flex-row"
          >
            <div class="tag" />
            <div class="title">预计到货时间</div>
            <div class="title" style="margin-left: 30px;">
              {{ _setTimeStr(product.EstimatedTime, 'date') }}
            </div>
          </div>
          <div
            v-if="getProductLabType(product).length || cusOtherInfo.IsShowPrice"
            class="goods-price-panel flex-row"
          >
            <div>
              <div class="goods-price">
                <div
                  v-html="
                    _showProductPrice(
                      product.PriceActivity,
                      product.PriceLimit,
                      fromPage == 'isArriving' || fromPage == 'newProduct'
                    )
                  "
                />
              </div>
              <div class="goods-price-calc">
                <div v-if="product.RetailPrice && product.RetailPrice != 0">
                  <span>{{ lang.Goods.RetailPrice
                  }}{{
                    `${lang.Basic.Price}${Number(product.RetailPrice).toFixed(
                      2
                    )}`
                  }}</span>
                  |
                  <span>
                    {{ lang.Goods.Profit
                    }}{{
                      _showProductProfit(
                        product.RetailPrice,
                        _getProductPrice(
                          product.PriceActivity,
                          product.PriceLimit
                        )
                      ) + '%'
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="goods-price-panel" style="min-height: 50px;">
            {{ cusOtherInfo.NoPriceTitle }}
          </div>
          <!-- <div v-if="product.IsOutBusinessScope" style="width: 25%;font-size: 12px;float: right">
						<van-button class="WanShaBtn" @click.stop="goConsummate(product.BusinessScope)" type="info">去完善</van-button>
					</div> -->
          <div class="goods-price-panel" @click.stop="">
            <AddCartButton
              :product="product"
              :from-page="fromPage"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="aGoodsType.includes(goodsType)">
      <div class="goods-item-agoods" @click="showProduct">
        <div class="goods-image">
          <div v-if="product.IsOutBusinessScope" class="overlay-text text1">
            {{ lang.Goods.Disabled_OverStep }}
          </div>
          <div
            v-else-if="product.IsSoldOut && fromPage == 'MyCollection'"
            class="overlay-text text"
          >
            已下架
          </div>
          <div
            v-else-if="
              (!product.Stock || product.Stock <= 0) &&
                !product.IsSoldOut &&
                fromPage != 'isArriving' &&
                !product.EstimatedTime
            "
            class="overlay-text text"
          >
            {{ lang.Goods.Disabled_Undercarriage }}
          </div>

          <img v-lazy="_getPic(product.img, true)">
        </div>
        <div
          v-if="getProductLabType(product).length"
          class="goods-activity-content"
        >
          <div
            :class="
              `goods-name flex-row ${
                product.NewProductTime &&
                moment().isBefore(moment(product.NewProductTime))
                  ? 'new'
                  : ''
              }`
            "
          >
            <div
              :class="
                `title van-ellipsis ${
                  product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
                    ? 'new-width'
                    : 'width'
                }`
              "
            >
              {{ product.name }}
            </div>
          </div>
          <div class="goods-price-panel" style="min-height: 50px;">
            <div class="hot-price-tag">
              <img :src="require('@/assets/goods/fire.png')">
              <span class="font">限时价</span>
            </div>
            <div class="hot-price flex-row">
              <div class="goods-activity-price">
                <span style="margin-right: -4px;">{{ lang.Basic.Price }}</span>
                {{ _getPriceArray(product.Price)[0] }}
                <span style="margin-left: -4px;">.</span>
                <span style="margin-left: -4px;">
                  {{
                    `
                 ${_getPriceArray(product.Price)[1]}`
                  }}
                </span>
                <span
                  v-if="product.IsOutBusinessScope"
                  class="WanShaSpanBtn"
                  type="info"
                  @click.stop="goConsummate(product.BusinessScope)"
                >去完善</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="goods-content" style="position: relative;">
          <div class="goods-name flex-row">
            <div
              :class="
                `title van-ellipsis ${
                  product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
                    ? 'new-width'
                    : 'width'
                }`
              "
            >
              {{ product.name }}
            </div>
          </div>
          <div
            class="goods-size"
            :style="{
              paddingBottom:
                !product.IsCoupon &&
                !product.IsFullReduction &&
                !product.IsFullGift &&
                !product.IsBuyAndGet &&
                !product.IsReturnableCoupon
                  ? '0.1rem'
                  : '0'
            }"
          >
            {{ `规格：${product.Specifications}` }}
          </div>
          <div class="goods-size">
            <div
              v-for="properties in product.CommodityListProperties"
              :key="properties.Id"
              class="goods-exp"
            >
              <!-- <van-tag plain :color="`${color[index % 4]}`">{{ properties.Abbreviation}}</van-tag> -->
              <span
                v-if="properties.AttributeName == '效期优于'"
                class="text van-ellipsis"
              >
                {{
                  properties.Abbreviation == '效'
                    ? '效期优于：' + properties.Value
                    : properties.Value
                }}
              </span>
            </div>
          </div>
          <div class="goods-activity-label">
            <div
              v-if="
                product.IsCoupon ||
                  product.IsFullReduction ||
                  product.IsFullGift ||
                  product.IsBuyAndGet ||
                  product.IsReturnableCoupon
              "
              class="flex-row"
              @click.stop="activeMore"
            >
              <div v-if="product.IsCoupon" class="tag">领券</div>
              <div v-if="product.IsFullReduction" class="tag">满减</div>
              <div v-if="product.IsFullGift" class="tag">满赠</div>
              <div v-if="product.IsBuyAndGet" class="tag">买赠</div>
              <div v-if="product.IsReturnableCoupon" class="tag">返券</div>
            </div>
          </div>
          <div
            v-if="getProductLabType(product).length || cusOtherInfo.IsShowPrice"
            class="goods-price-panel flex-row"
            style="min-height: 50px;"
          >
            <div>
              <div class="goods-price">
                <div
                  v-html="
                    _showProductPrice(
                      product.PriceActivity,
                      product.PriceLimit,
                      fromPage == 'isArriving' || fromPage == 'newProduct'
                    )
                  "
                />
              </div>
              <div class="goods-price-calc">
                <div v-if="product.RetailPrice && product.RetailPrice != 0">
                  <span>{{ lang.Goods.RetailPrice
                  }}{{
                    `${lang.Basic.Price}${Number(product.RetailPrice).toFixed(
                      2
                    )}`
                  }}</span>
                  |
                  <span>
                    {{ lang.Goods.Profit
                    }}{{
                      _showProductProfit(
                        product.RetailPrice,
                        _getProductPrice(
                          product.PriceActivity,
                          product.PriceLimit
                        )
                      ) + '%'
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="goods-price-panel" style="min-height: 50px;">
            {{ cusOtherInfo.NoPriceTitle }}
          </div>
          <!-- <div v-if="product.IsOutBusinessScope" style="width: 25%;font-size: 12px;float: right">
						<van-button class="WanShaBtn" @click.stop="goConsummate(product.BusinessScope)" type="info">去完善</van-button>
					</div> -->
          <div
            class="goods-price-panel"
            style="position: absolute; right: 0; bottom: 3px; display: none; width: 100%; height: 60px;"
          >
            <AddCartButton
              :product="product"
              style="width: 100%; height: 100%; background-color: white;"
              :from-page="fromPage"
            />
          </div>
        </div>
      </div>
    </template>
    <!-- 首页第一行数据栅格 -->
    <template v-else-if="vGoodsType.includes(goodsType)">
      <div
        class="goods-item-vgoods"
        @click="showProduct"
        @mouseenter="showBuycar(true)"
        @mouseleave="showBuycar(false)"
      >
        <div class="goods-image">
          <div v-if="product.IsOutBusinessScope" class="overlay-text text1">
            {{ lang.Goods.Disabled_OverStep }}
          </div>
          <div
            v-else-if="product.IsSoldOut && fromPage == 'MyCollection'"
            class="overlay-text text"
          >
            已下架
          </div>
          <div
            v-else-if="
              (!product.Stock || product.Stock <= 0) &&
                !product.IsSoldOut &&
                fromPage != 'isArriving' &&
                !product.EstimatedTime
            "
            class="overlay-text text"
          >
            {{ lang.Goods.Disabled_Undercarriage }}
          </div>

          <img v-lazy="_getPic(product.img, true)">
          <div
            v-if="firstTime.length > 0"
            :class="
              `${
                product.NewProductTime
                  ? 'goods-activity-new'
                  : product.EstimatedTime
                    ? 'goods-activity-soon'
                    : ''
              } flex-row`
            "
          >
            <div class="text">仅剩{{ firstTime[3] }}天</div>
            <div class="text">
              <span class="span">{{ firstTime[0] }}</span>
              <span style="text-align: center;">时</span>
              <span class="span">{{ firstTime[1] }}</span>
              <span style="text-align: center;">分</span>
            </div>
          </div>
        </div>
        <div
          v-if="getProductLabType(product).length"
          class="goods-activity-content"
        >
          <div
            :class="
              `goods-name flex-row align-items-center ${
                product.NewProductTime &&
                moment().isBefore(moment(product.NewProductTime))
                  ? 'new'
                  : ''
              }`
            "
          >
            <div v-if="isShowbuycar" class="showtopbar">
              <slot name="topbar" />
            </div>
            <!-- 医保标签标签 -->
            <div
              v-for="properties in product.CommodityListProperties"
              v-if="properties.AttributeName == '医保类型'"
              :key="properties.Id"
              style="margin-right: 4px; font-size: 0;"
            >
              <img
                v-if="properties.Value == 1"
                src="@/assets/goods/class_a.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 2"
                src="@/assets/goods/class_b.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 3"
                src="@/assets/goods/yibao.png"
                width="28px"
                height="16px"
              >
            </div>
            <img
              v-if="
                product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
              "
              src="@/assets/goods/new.png"
              style="margin-right: 4px; width: 30px;"
            >

            <!-- 商品标签 -->
            <img
              v-if="product.GoodsTags.length"
              :src="product.GoodsTags[0].Img"
              style="width: 32px; height: 16px;"
            >
            <div
              :class="
                `title van-ellipsis ${
                  product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
                    ? 'new-width'
                    : 'width'
                }`
              "
            >
              {{ product.name }}
            </div>
          </div>
          <div
            class="goods-price-panel"
            style="min-height: 50px;"
            @click.stop=""
          >
            <div class="hot-price-tag">
              <img
                :src="require('@/assets/goods/fire.png')"
                style="margin-top: -14px;"
              >
              <span class="font">限时价</span>
              <!-- <span v-if="product.IsOutBusinessScope" style="width: 25%;font-size: 12px;float: right;">
								<van-button class="WanShaBtn" @click.stop="goConsummate(product.BusinessScope)" type="info">去完善</van-button>
							</span> -->
            </div>

            <div class="hot-price flex-row">
              <div class="goods-activity-price">
                <span style="margin-right: -4px;">{{ lang.Basic.Price }}</span>
                {{ _getPriceArray(product.Price)[0] }}
                <span style="margin-left: -4px;">.</span>
                <span style="margin-left: -4px;">
                  {{
                    `
                 ${_getPriceArray(product.Price)[1]}`
                  }}
                </span>
              </div>
              <div v-if="isShowbuycar" class="showbuycar">
                <AddCartButton
                  :product="product"
                  :from-page="goodsType"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-else class="goods-content">
          <div class="goods-name flex-row align-items-center">
            <div v-if="isShowbuycar" class="showtopbar">
              <slot name="topbar" />
            </div>
            <!-- 医保标签标签 -->
            <div
              v-for="properties in product.CommodityListProperties"
              v-if="properties.AttributeName == '医保类型'"
              :key="properties.Id"
              style="margin-right: 4px; font-size: 0;"
            >
              <img
                v-if="properties.Value == 1"
                src="@/assets/goods/class_a.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 2"
                src="@/assets/goods/class_b.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 3"
                src="@/assets/goods/yibao.png"
                width="28px"
                height="16px"
              >
            </div>
            <!-- <div v-if="product.NewProductTime && moment().isBefore(moment(product.NewProductTime))" class="newTag">新品</div> -->
            <img
              v-if="
                product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
              "
              src="@/assets/goods/new.png"
              style="margin-right: 4px; width: 30px;"
            >

            <!-- 商品标签 -->
            <img
              v-if="product.GoodsTags.length"
              :src="product.GoodsTags[0].Img"
              style="width: 32px; height: 16px;"
            >
            <div
              :class="
                `title van-ellipsis ${
                  product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
                    ? 'new-width'
                    : 'width'
                }`
              "
            >
              {{ product.name }}
            </div>
          </div>
          <div
            class="goods-size"
            :style="{
              paddingBottom:
                !product.IsCoupon &&
                !product.IsFullReduction &&
                !product.IsFullGift &&
                !product.IsBuyAndGet &&
                !product.IsReturnableCoupon
                  ? '0.1rem'
                  : '0'
            }"
          >
            {{ `规格：${product.Specifications}` }}
          </div>
          <div class="goods-size">
            <div
              v-for="properties in product.CommodityListProperties"
              :key="properties.Id"
              class="goods-exp"
            >
              <!-- <van-tag plain :color="`${color[index % 4]}`">{{ properties.Abbreviation}}</van-tag> -->
              <span
                v-if="properties.AttributeName == '效期优于'"
                class="text van-ellipsis"
              >
                {{
                  properties.Abbreviation == '效'
                    ? '效期优于：' + properties.Value
                    : properties.Value
                }}
              </span>
            </div>
          </div>
          <div class="goods-activity-label">
            <div
              v-if="
                product.IsCoupon ||
                  product.IsFullReduction ||
                  product.IsFullGift ||
                  product.IsBuyAndGet ||
                  product.IsReturnableCoupon
              "
              class="flex-row"
              @click.stop="activeMore"
            >
              <div v-if="product.IsCoupon" class="tag">领券</div>
              <div v-if="product.IsFullReduction" class="tag">满减</div>
              <div v-if="product.IsFullGift" class="tag">满赠</div>
              <div v-if="product.IsBuyAndGet" class="tag">买赠</div>
              <div v-if="product.IsReturnableCoupon" class="tag">返券</div>
            </div>
          </div>
          <div
            v-if="getProductLabType(product).length || cusOtherInfo.IsShowPrice"
            class="goods-price-panel"
            style="min-height: 50px;"
            @click.stop=""
          >
            <div>
              <div class="goods-price">
                <div
                  v-html="
                    _showProductPrice(
                      product.PriceActivity,
                      product.PriceLimit,
                      fromPage == 'isArriving' || fromPage == 'newProduct'
                    )
                  "
                />
              </div>
              <div class="goods-price-calc">
                <div v-if="product.RetailPrice && product.RetailPrice != 0">
                  <span>{{ lang.Goods.RetailPrice
                  }}{{
                    `${lang.Basic.Price}${Number(product.RetailPrice).toFixed(
                      2
                    )}`
                  }}</span>
                  |
                  <span>
                    {{ lang.Goods.Profit
                    }}{{
                      _showProductProfit(
                        product.RetailPrice,
                        _getProductPrice(
                          product.PriceActivity,
                          product.PriceLimit
                        )
                      ) + '%'
                    }}
                  </span>
                </div>
              </div>
              <div v-if="isShowbuycar" class="showbuycar">
                <AddCartButton
                  :product="product"
                  :from-page="goodsType"
                />
              </div>
            </div>
          </div>
          <div
            v-else
            class="goods-price-panel"
            style="float: left; width: 70%; min-height: 50px;"
          >
            {{ cusOtherInfo.NoPriceTitle }}
          </div>
          <!-- xuzhongqi -->
          <!-- <div v-show="product.IsOutBusinessScope && isShowbuycar" style="margin-top: -54px;text-align: right; width: 100%;">
						<van-button class="WanShaBtn" @click.stop="goConsummate(product.BusinessScope)" type="info">去完善</van-button>
					</div> -->
          <div v-show="product.IsOutBusinessScope && isShowbuycar">
            <van-button
              style="position: absolute; bottom: -50px; left: 0; border-radius: 0; width: 100%; height: 60px; font-size: 18px; font-weight: bold;"
              type="info"
              @click.stop="goConsummate(product.BusinessScope)"
            >去完善</van-button>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="sGoodsType.includes(goodsType)">
      <div class="goods-item-sgoods" @click="showProduct">
        <div class="goods-image">
          <div
            v-if="product.IsOutBusinessScope && fromPage != 'brand'"
            class="overlay-text text1"
          >
            {{ lang.Goods.Disabled_OverStep }}
          </div>
          <div
            v-else-if="
              product.IsSoldOut &&
                fromPage == 'MyCollection' &&
                fromPage != 'brand'
            "
            class="overlay-text text"
          >
            已下架
          </div>
          <div
            v-else-if="
              (!product.Stock || product.Stock <= 0) &&
                !product.IsSoldOut &&
                fromPage != 'brand' &&
                fromPage != 'isArriving' &&
                !product.EstimatedTime
            "
            class="overlay-text text"
          >
            {{ lang.Goods.Disabled_Undercarriage }}
          </div>

          <img v-lazy="_getPic(product.img, true)">
        </div>
        <div
          v-if="getProductLabType(product).length"
          class="goods-activity-content"
        >
          <div
            :class="
              `goods-name flex-row align-items-center justify-content-center`
            "
          >
            <!-- 医保标签标签 -->
            <div
              v-for="properties in product.CommodityListProperties"
              v-if="properties.AttributeName == '医保类型'"
              :key="properties.Id"
              style="margin-right: 4px; font-size: 0;"
            >
              <img
                v-if="properties.Value == 1"
                src="@/assets/goods/class_a.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 2"
                src="@/assets/goods/class_b.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 3"
                src="@/assets/goods/yibao.png"
                width="28px"
                height="16px"
              >
            </div>
            <img
              v-if="
                product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
              "
              src="@/assets/goods/new.png"
              style="margin-right: 4px; width: 30px;"
            >

            <!-- 商品标签 -->
            <img
              v-if="product.GoodsTags.length"
              :src="product.GoodsTags[0].Img"
              style="width: 32px; height: 16px;"
            >
            <div :class="`title van-ellipsis `">{{ product.name }}</div>
          </div>
          <div class="goods-price-panel" style="min-height: 50px;">
            <div class="hot-price-tag">
              <img
                :src="require('@/assets/goods/fire.png')"
                style="top: -5px;"
              >
              <span class="font">
                限时价
                <span style="margin-right: -4px;">{{ lang.Basic.Price }}</span>
                <span class="price">{{
                  _getPriceArray(product.Price)[0]
                }}</span>
                <span style="margin-left: -6px;">
                  {{
                    `.
                 ${_getPriceArray(product.Price)[1]}`
                  }}
                </span>
              </span>
              <!-- <span v-if="product.IsOutBusinessScope" class="WanShaSpanBtn" @click.stop="goConsummate(product.BusinessScope)" type="info">去完善</span> -->
            </div>
          </div>
        </div>
        <div v-else class="goods-content">
          <!-- ${product.NewProductTime && moment().isBefore(moment(product.NewProductTime))?'new':''} -->
          <div
            :class="
              `goods-name flex-row align-items-center justify-content-center`
            "
          >
            <!-- <div v-if="product.NewProductTime && moment().isBefore(moment(product.NewProductTime))" class="newTag">新品</div> -->
            <!-- ${product.NewProductTime && moment().isBefore(moment(product.NewProductTime))?'new-width':'width'} -->
            <img
              v-if="
                product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
              "
              src="@/assets/goods/new.png"
              style="margin-right: 4px; width: 30px;"
            >
            <!-- 医保标签标签 -->
            <div
              v-for="properties in product.CommodityListProperties"
              v-if="properties.AttributeName == '医保类型'"
              :key="properties.Id"
              style="margin-right: 4px; font-size: 0;"
            >
              <img
                v-if="properties.Value == 1"
                src="@/assets/goods/class_a.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 2"
                src="@/assets/goods/class_b.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 3"
                src="@/assets/goods/yibao.png"
                width="28px"
                height="16px"
              >
            </div>
            <!-- 商品标签 -->
            <img
              v-if="product.GoodsTags.length"
              :src="product.GoodsTags[0].Img"
              style="width: 32px; height: 16px;"
            >
            <div :class="`title van-ellipsis `">{{ product.name }}</div>
          </div>
          <div
            v-if="getProductLabType(product).length || cusOtherInfo.IsShowPrice"
            class="goods-price-panel"
            style="min-height: 50px;"
          >
            <div>
              <div class="goods-price">
                <div
                  v-html="
                    _showProductPrice(
                      product.PriceActivity,
                      product.PriceLimit,
                      fromPage == 'isArriving' || fromPage == 'newProduct'
                    )
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="rGoodsType.includes(goodsType)">
      <div
        class="goods-item-vgoods "
        style=" height: auto; min-height: auto;"
        @click="showProduct"
        @mouseenter="showBuycar(true)"
        @mouseleave="showBuycar(false)"
      >
        <div class="goods-image">
          <div v-if="product.IsOutBusinessScope" class="overlay-text text1">
            {{ lang.Goods.Disabled_OverStep }}
          </div>
          <div
            v-else-if="product.IsSoldOut && fromPage == 'MyCollection'"
            class="overlay-text text"
          >
            已下架
          </div>
          <div
            v-else-if="
              (!product.Stock || product.Stock <= 0) &&
                !product.IsSoldOut &&
                fromPage != 'isArriving' &&
                !product.EstimatedTime
            "
            class="overlay-text text"
          >
            {{ lang.Goods.Disabled_Undercarriage }}
          </div>
          <img v-lazy="_getPic(product.img, true)">
          <div
            v-if="firstTime.length > 0"
            :class="
              `${
                product.NewProductTime
                  ? 'goods-activity-new'
                  : product.EstimatedTime
                    ? 'goods-activity-soon'
                    : ''
              } flex-row`
            "
          >
            <div class="text">仅剩{{ firstTime[3] }}天</div>
            <div class="text">
              <span class="span">{{ firstTime[0] }}</span>
              <span style="text-align: center;">时</span>
              <span class="span">{{ firstTime[1] }}</span>
              <span style="text-align: center;">分</span>
            </div>
          </div>
        </div>
        <div
          v-if="getProductLabType(product).length"
          class="goods-activity-content"
        >
          <div
            :class="
              `goods-name flex-row ${
                product.NewProductTime &&
                moment().isBefore(moment(product.NewProductTime))
                  ? 'new'
                  : ''
              }`
            "
          >
            <div v-if="isShowbuycar" class="showtopbar">
              <slot name="topbar" />
            </div>
            <img
              v-if="
                product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
              "
              src="@/assets/goods/new.png"
              style="margin-right: 4px; width: 30px;"
            >
            <!-- 医保标签标签 -->
            <div
              v-for="properties in product.CommodityListProperties"
              v-if="properties.AttributeName == '医保类型'"
              :key="properties.Id"
              style="margin-right: 4px; font-size: 0;"
            >
              <img
                v-if="properties.Value == 1"
                src="@/assets/goods/class_a.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 2"
                src="@/assets/goods/class_b.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 3"
                src="@/assets/goods/yibao.png"
                width="28px"
                height="16px"
              >
            </div>
            <!-- 商品标签 -->
            <img
              v-if="product.GoodsTags.length"
              :src="product.GoodsTags[0].Img"
              style="width: 32px; height: 16px;"
            >
            <div
              :class="
                `title van-ellipsis ${
                  product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
                    ? 'new-width'
                    : 'width'
                }`
              "
            >
              {{ product.name }}
            </div>
          </div>
          <div
            class="goods-price-panel"
            style="min-height: auto;"
            @click.stop=""
          >
            <div class="hot-price-tag">
              <img :src="require('@/assets/goods/fire.png')">
              <span class="font">限时价</span>
            </div>
            <div class="hot-price flex-row">
              <div class="goods-activity-price">
                <span style="margin-right: -4px;">{{ lang.Basic.Price }}</span>
                {{ _getPriceArray(product.Price)[0] }}
                <span style="margin-left: -4px;">.</span>
                <span style="margin-left: -4px;">
                  {{
                    `
                 ${_getPriceArray(product.Price)[1]}`
                  }}
                </span>
                <!-- <span v-if="product.IsOutBusinessScope" class="WanShaSpanBtn" @click.stop="goConsummate(product.BusinessScope)" type="info">去完善</span> -->
              </div>
              <div v-if="isShowbuycar" class="showbuycar">
                <AddCartButton
                  :product="product"
                  :from-page="goodsType"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-else class="goods-content">
          <div class="goods-name flex-row align-items-center">
            <div v-if="isShowbuycar" class="showtopbar">
              <slot name="topbar" />
            </div>
            <img
              v-if="
                product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
              "
              src="@/assets/goods/new.png"
              style="margin-right: 4px; width: 30px;"
            >
            <!-- 医保标签标签 -->
            <div
              v-for="properties in product.CommodityListProperties"
              v-if="properties.AttributeName == '医保类型'"
              :key="properties.Id"
              style="margin-right: 4px; font-size: 0;"
            >
              <img
                v-if="properties.Value == 1"
                src="@/assets/goods/class_a.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 2"
                src="@/assets/goods/class_b.png"
                width="28px"
                height="16px"
              >
              <img
                v-if="properties.Value == 3"
                src="@/assets/goods/yibao.png"
                width="28px"
                height="16px"
              >
            </div>
            <!-- 商品标签 -->
            <img
              v-if="product.GoodsTags.length"
              :src="product.GoodsTags[0].Img"
              style="width: 32px; height: 16px;"
            >
            <div
              :class="
                `title van-ellipsis ${
                  product.NewProductTime &&
                  moment().isBefore(moment(product.NewProductTime))
                    ? 'new-width'
                    : 'width'
                }`
              "
            >
              {{ product.name }}
            </div>
          </div>
          <div
            class="goods-size"
            :style="{
              paddingBottom:
                !product.IsCoupon &&
                !product.IsFullReduction &&
                !product.IsFullGift &&
                !product.IsBuyAndGet &&
                !product.IsReturnableCoupon
                  ? '0.1rem'
                  : '0'
            }"
          >
            {{ `规格：${product.Specifications}` }}
          </div>
          <div class="goods-size">
            <div
              v-for="properties in product.CommodityListProperties"
              :key="properties.Id"
              class="goods-exp"
            >
              <!-- <van-tag plain :color="`${color[index % 4]}`">{{ properties.Abbreviation}}</van-tag> -->
              <span
                v-if="properties.AttributeName == '效期优于'"
                class="text van-ellipsis"
              >
                {{
                  properties.Abbreviation == '效'
                    ? '效期优于：' + properties.Value
                    : properties.Value
                }}
              </span>
            </div>
          </div>
          <div class="goods-activity-label" style="min-height: auto;">
            <div
              v-if="
                product.IsCoupon ||
                  product.IsFullReduction ||
                  product.IsFullGift ||
                  product.IsBuyAndGet ||
                  product.IsReturnableCoupon
              "
              class="flex-row"
              @click.stop="activeMore"
            >
              <div v-if="product.IsCoupon" class="tag">领券</div>
              <div v-if="product.IsFullReduction" class="tag">满减</div>
              <div v-if="product.IsFullGift" class="tag">满赠</div>
              <div v-if="product.IsBuyAndGet" class="tag">买赠</div>
              <div v-if="product.IsReturnableCoupon" class="tag">返券</div>
            </div>
          </div>
          <div
            v-if="getProductLabType(product).length || cusOtherInfo.IsShowPrice"
            class="goods-price-panel"
            style="min-height: auto;"
            @click.stop=""
          >
            <div>
              <div class="goods-price">
                <div
                  v-html="
                    _showProductPrice(
                      product.PriceActivity,
                      product.PriceLimit,
                      fromPage == 'isArriving' || fromPage == 'newProduct'
                    )
                  "
                />
              </div>
              <div v-if="false" class="goods-price-calc">
                <div v-if="product.RetailPrice && product.RetailPrice != 0">
                  <span>{{ lang.Goods.RetailPrice
                  }}{{
                    `${lang.Basic.Price}${Number(product.RetailPrice).toFixed(
                      2
                    )}`
                  }}</span>
                  |
                  <span>
                    {{ lang.Goods.Profit
                    }}{{
                      _showProductProfit(
                        product.RetailPrice,
                        _getProductPrice(
                          product.PriceActivity,
                          product.PriceLimit
                        )
                      ) + '%'
                    }}
                  </span>
                </div>
              </div>
              <div v-if="isShowbuycar" class="showbuycar">
                <AddCartButton
                  :product="product"
                  :from-page="goodsType"
                />
              </div>
            </div>
          </div>
          <div v-else class="goods-price-panel" style="min-height: auto;">
            {{ cusOtherInfo.NoPriceTitle }}
          </div>
          <!-- <div v-if="product.IsOutBusinessScope" style="width: 25%;font-size: 12px;float: right;margin-top: -10%">
						<van-button class="WanShaBtn" @click.stop="goConsummate(product.BusinessScope)" type="info">去完善</van-button>
					</div> -->
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import AddCartButton from '@/components/AddCartButton'
import { BaseMixin } from '@/mixins/BaseMixin'
import { LinkTypeCode } from '@/dictionary/base'
export default {
  name: 'ProductListItem',
  components: { AddCartButton },
  mixins: [BaseMixin],
  props: {
    product: {
      type: Object,
      default() {
        return {}
      }
    },
    checkbox: {
      type: Boolean,
      default: false
    },
    fromPage: {
      type: String,
      default: null
    },
    goodsType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      color: ['red', 'orange', 'blue', 'green'],
      goodsActivity: {},
      timer: {},
      firstTime: [],
      isShowbuycar: false,
      lGoodsType: ['ListArrivingGoods', 'ListNewGoods'],
      hGoodsType: ['HomeNewGoods'],
      vGoodsType: ['HomeHotGoods', 'VGoods'],
      aGoodsType: ['ActivityAreaGoods'],
      sGoodsType: ['HomeSmallGoods'],
      rGoodsType: ['RecommendGoods'],
      cusOtherInfo: {
        IsShowPrice: false,
        IsOrder: false,
        NoPriceTitle: '暂无价格'
      }
    }
  },
  created() {
    this.goodsActivity = this._analysisGoodsActivity(
      this.product.SalesPromotions
    )
    this.product.goodsActivity = this.goodsActivity

    // 倒计时显示顺序  即将到货 < 新品 < 特价
    let productTime = this.product.NewProductTime

    if (!this.product.NewProductTime) {
      productTime = this.product.EstimatedTime
    } else if (this.fromPage == 'isArriving') {
      productTime = this.product.EstimatedTime
    } else if (this.goodsActivity) {
      productTime = this.goodsActivity.FirstEnd.EndTime
    }

    if (productTime) {
      this.timer = setInterval(() => {
        const array = this._analysisActivityDiffTime(productTime, moment())
        const firstTime = this._setTimerArr(array[1])
        let flag = true
        const constDays = array[0].length > 1 ? array[0] : '0' + array[0]
        firstTime.push(constDays)
        firstTime.push(array[0])
        firstTime.forEach((t) => {
          if (Number(t) < 0) {
            clearInterval(this.timer)
            flag = false
          }
        })
        if (flag) {
          this.firstTime = firstTime
        }
      }, 1000)
    }
  },
  mounted() {
    const info = this.$auth.getCustomerOtherInfo()
    if (info) {
      this.cusOtherInfo = info
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    moment,
    // 完善商品首营
    async goConsummate(param) {
      const that = this
      let type = ''
      const res = await this.getAction(
        '/api_goods/GoodsSku/GetCertificateByBusinessCope',
        { businessCode: param }
      )
      if (res.IsSuccess) {
        type = res.Data
        const message =
          type == '1'
            ? '药品经营许可证'
            : type == '2'
              ? '第二类医疗器械经营备案凭证'
              : type == '3'
                ? '医疗器械经营许可证'
                : '食品经营许可证'
        this.$confirm({
          title: '提示',
          content: '你需要提交包含' + message + '，才可以购买商品',
          okText: '去完善',
          cancelText: '取消',
          onOk() {
            that.go(type)
          },
          onCancel() {}
        })
      } else {
        this.$router.push({
          name: LinkTypeCode.MyQualifications,
          params: { type: '' }
        })
      }
    },
    go(type) {
      this.$router.push({
        name: LinkTypeCode.MyQualifications,
        params: { type: type }
      })
    },
    // 展示商品详情
    showProduct: function() {
      this.$emit('showProduct')
    },
    // 增加到购物车
    productAddCart: function(e) {
      this.$nextTick(() => {
        this.$emit('productAddCart', e, this.product)
      })
    },
    // 购物车返回
    addCartOK: function(item) {
      this.product.cartNum = item.cartNum
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    // 到货通知
    SubNotice: function() {
      this.$emit('SubNotice', this.product)
    },
    // 取消订阅
    CancelSub: function() {
      this.$emit('CancelSub', this.product)
    },
    // ...活动信息
    activeMore: function() {
      this.$nextTick(() => {
        this.$emit('handleActiveMore', this.product)
      })
    },
    // 商品是否是特价商品
    getProductLabType(item) {
      let list = []
      if (item.OutLabelDtos && item.OutLabelDtos.length) {
        list = item.OutLabelDtos.filter((tag) => tag.Name.indexOf('特价') != -1)
      }
      return list
    },
    showBuycar(flag) {
      if (this.goodsType != 'HomeHotGoods') {
        this.isShowbuycar = flag
      } else {
        this.isShowbuycar = false
      }
    }
  }
}
</script>

<style lang="less">
#goods-item {
  cursor: pointer;

  img {
    transition: all .5s;
  }

  &:hover {
    img {
      transform: scale(1.03);
    }
  }

  .flex-row {
    display: flex;
    flex-direction: row;
  }

  .goods-item-hgoods {
    display: flex;
    padding-top: 30px;
    width: 470px;
    max-width: 470px;
    background: #FFFFFF;

    > .goods-image {
      position: relative;
      overflow: hidden;
      padding: 0 10px;
      min-width: 200px;
      max-width: 200px;
      min-height: 200px;
      max-height: 200px;
      line-height: 200px;

      > img {
        display: inline-block;
        max-width: 200px;
        max-height: 200px;
        vertical-align: middle;
      }

      .overlay-text {
        position: absolute;
        z-index: 2;
        margin: 20px 25px;
        border-radius: 50%;
        width: 150px;
        height: 150px;
        color: #FFFFFF;
        background: rgba(0, 0, 0, 1);
        opacity: .6;
        transform: rotate(-45deg);
        line-height: 150px;
        letter-spacing: 0;
      }

      .text {
        font-size: 18px;
      }
    }

    > .goods-content {
      margin-left: 10px;
      width: calc(100% - 220px);
      text-align: left;
      // display: flex;
      // flex-direction: column;
      // justify-content: space-between;

      > .goods-name {
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 10px;

        > .newTag {
          margin-top: 2px;
          width: 40px;
          height: 22px;
          font-size: 16px;
          font-weight: 600;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          background: linear-gradient(#85B2FF, #6B90FF);
        }

        > .title {
          font-size: 18px;
          font-weight: 400;
          color: rgba(34, 34, 34, 1);
        }

        > .new-width {
          margin-left: 6px;
          width: 160px;
        }

        > .width {
          width: 200px;
        }
      }

      > .goods-size {
        margin-top: 2px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(119, 119, 119, 1);

        > .goods-exp {
          width: 200px;
        }
      }

      > .goods-activity-label {
        overflow: hidden;
        margin-top: 10px;
        height: 30px;

        > .flex {
          display: flex;
          flex-direction: row;
        }

        .tag {
          margin-right: .2rem;
          border: #FE3F3F 1px solid;
          border-radius: 2px;
          width: 36px;
          height: 20px;
          font-size: 12px;
          font-weight: 400;
          text-align: center;
          color: rgba(255, 57, 57, 1);
          background: #FFF3F3;
          line-height: 20px;
        }

        .tag:last-child {
          margin-right: 0;
        }
      }

      > .goods-price-panel {
        .goods-price {
          .goods-activity-price {
            font-size: 24px;
            font-weight: 800;
            color: rgba(255, 57, 57, 1);

            span {
              font-size: 14px;
              //   margin-right: 1px;
            }
          }

          .goods-original-price {
            margin-left: .15rem;
            color: #777777;
            line-height: .33rem;

            span {
              margin-right: -.05rem;
              font-size: .24rem;
            }
          }
        }

        .goods-price-calc {
          width: 90%;
          font-size: 14px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }

        .goods-add-cart {
          border-radius: 2px;
          width: 96px;
          height: 28px;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          background: rgba(255, 57, 57, 1);
          line-height: 28px;
          cursor: pointer;
        }
      }
    }
  }

  .goods-item-lgoods {
    display: flex;
    width: 590px;
    max-width: 590px;
    height: 280px;
    max-height: 280px;
    background: #FFFFFF;

    > .goods-image {
      position: relative;
      overflow: hidden;
      margin: 20px;
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 1px;
      min-width: 240px;
      max-width: 240px;
      min-height: 240px;
      max-height: 240px;
      line-height: 240px;

      > img {
        display: inline-block;
        width: 100%;
        height: 100%;
        //vertical-align: middle;
      }

      .overlay-text {
        position: absolute;
        z-index: 2;
        margin: 25px 40px;
        border-radius: 50%;
        width: 150px;
        height: 150px;
        color: #FFFFFF;
        background: rgba(0, 0, 0, 1);
        opacity: .6;
        transform: rotate(-45deg);
        line-height: 150px;
        letter-spacing: 0;
      }

      .text {
        font-size: 18px;
      }

      .goods-activity-new {
        position: relative;
        top: -45px;
        justify-content: flex-end;
        padding-right: 10px;
        max-width: 240px;
        height: 41px;
        text-align: center;
        background: url('../assets/goods/newgoods.png') no-repeat;
        background-size: 245px 41px;

        > .text {
          font-size: 14px;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          line-height: 41px;

          .span {
            font-size: 14px;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }

    > .goods-content {
      display: flex;
      justify-content: space-between;
      margin: 20px 0;
      text-align: left;
      flex-direction: column;

      > .goods-name {
        justify-content: flex-start;
        margin-bottom: 4px;

        > .newTag {
          margin-top: .5px;
          margin-right: 2px;
          padding: 1px;
          width: 40px;
          height: 22px;
          font-size: 16px;
          font-weight: 600;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          background: linear-gradient(#85B2FF, #6B90FF);
          line-height: 22px;
        }

        > .title {
          font-size: 18px;
          color: rgba(34, 34, 34, 1);
        }

        > .width {
          width: 280px;
        }

        > .new-width {
          width: 250px;
        }
      }

      > .goods-size {
        font-size: 14px;
        color: rgba(119, 119, 119, 1);

        > .goods-exp {
          width: 270px;
        }
      }

      > .goods-activity-label {
        overflow: hidden;
        margin: 5px 0;

        > .flex {
          display: flex;
          flex-direction: row;
        }

        .tag {
          margin-right: .2rem;
          border: #FE3F3F 1px solid;
          border-radius: 2px;
          width: 36px;
          height: 20px;
          font-size: 12px;
          font-weight: 400;
          text-align: center;
          color: rgba(255, 57, 57, 1);
          background: #FFF3F3;
          line-height: 20px;
        }

        .tag:last-child {
          margin-right: 0;
        }
      }

      > .goods-price-panel {
        .goods-price {
          .goods-activity-price {
            font-size: 24px;
            font-weight: 800;
            color: rgba(255, 57, 57, 1);

            span {
              font-size: 14px;
              //   margin-right: 1px;
            }
          }
        }

        .goods-price-calc {
          font-size: 14px;
          color: rgba(153, 153, 153, 1);
        }

        .goods-add-cart {
          border-radius: 2px;
          width: 96px;
          height: 28px;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          background: rgba(255, 57, 57, 1);
          line-height: 28px;
          cursor: pointer;
        }
      }

      > .goods-activity-panel {
        > .tag {
          width: 20px;
          height: 20px;
          background: url('../assets/order/daifukuan-icon.png') no-repeat center;
          background-size: 13px 13px;
        }

        > .title {
          margin-left: 4px;
          font-size: 14px;
          font-weight: 600;
          color: rgba(255, 57, 57, 1);
          line-height: 20px;
        }
      }
    }
  }

  .goods-item-agoods {
    // background: rgba(249, 249, 249, 1);
    border-radius: 2px;
    width: 285px;
    max-width: 285px;
    height: 451px;
    min-height: 451px;
    background: #FFFFFF;
    // padding-bottom: 15px;

    .goods-image {
      position: relative;
      overflow: hidden;
      margin: 20px;
      min-width: 245px;
      max-width: 245px;
      min-height: 245px;
      max-height: 245px;
      line-height: 245px;

      > img {
        display: inline-block;
        max-width: 245px;
        max-height: 245px;
      }

      .overlay-text {
        position: absolute;
        z-index: 2;
        margin: 30px 40px;
        border-radius: 50%;
        width: 180px;
        height: 180px;
        color: #FFFFFF;
        background: rgba(0, 0, 0, 1);
        opacity: .6;
        transform: rotate(-45deg);
        line-height: 180px;
        letter-spacing: 0;
      }

      .text {
        font-size: 18px;
      }

      .goods-activity-soon,
      .goods-activity-new {
        position: relative;
        top: -41px;
        justify-content: flex-end;
        padding-right: 10px;
        max-width: 245px;
        height: 41px;
        text-align: center;
        background: url('../assets/goods/newgoods.png') no-repeat;
        background-size: 245px 41px;

        > .text {
          font-size: 14px;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          line-height: 41px;

          .span {
            font-size: 14px;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
          }
        }
      }

      .goods-activity-soon {
        position: relative;
        top: -41px;
        justify-content: flex-end;
        padding-right: 10px;
        max-width: 245px;
        height: 41px;
        text-align: center;
        background: url('../assets/goods/soongoods.png') no-repeat;
        background-size: 245px 41px;
      }
    }

    .goods-content {
      padding: 0 20px;
      padding-bottom: 15px;
      text-align: left;

      > .goods-name {
        margin-bottom: 6px;

        > .newTag {
          margin-top: 2px;
          width: 40px;
          height: 22px;
          font-size: 16px;
          font-weight: 600;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          background: linear-gradient(#85B2FF, #6B90FF);
        }

        > .title {
          margin-left: 6px;
          font-size: 18px;
          font-weight: 400;
          color: rgba(34, 34, 34, 1);
        }
      }

      > .goods-size {
        font-size: 14px;
        font-weight: 400;
        color: rgba(119, 119, 119, 1);
        line-height: 20px;

        .goods-exp {
          width: 200px;
        }
      }

      > .goods-activity-label {
        overflow: hidden;
        margin-top: 4px;
        height: 30px;

        .tag {
          margin-right: .2rem;
          border: #FE3F3F 1px solid;
          border-radius: 2px;
          width: 36px;
          height: 20px;
          font-size: 12px;
          font-weight: 400;
          text-align: center;
          color: rgba(255, 57, 57, 1);
          background: #FFE4E5;
          line-height: 20px;
        }

        .tag:last-child {
          margin-right: 0;
        }
      }

      > .goods-price-panel {
        justify-content: space-between;

        .goods-price {
          .goods-activity-price {
            font-size: 24px;
            font-weight: 800;
            color: rgba(255, 57, 57, 1);

            span {
              font-size: 14px;
              //   margin-right: 1px;
            }
          }

          .goods-original-price {
            margin-left: .15rem;
            color: #777777;
            line-height: .33rem;

            span {
              margin-right: -.05rem;
              font-size: .24rem;
            }
          }
        }

        .goods-price-calc {
          font-size: 14px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }

        .goods-add-cart {
          border-radius: 2px;
          width: 96px;
          height: 28px;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          background: rgba(255, 57, 57, 1);
          line-height: 28px;
          cursor: pointer;
        }
      }
    }

    .goods-activity-content {
      padding: 0 20px;
      text-align: center;

      .goods-name {
        margin-bottom: 14px;

        > .title {
          margin-left: 6px;
          font-size: 18px;
          font-weight: 400;
          text-align: center;
          color: rgba(34, 34, 34, 1);
        }

        > .width {
          width: 240px;
        }
      }

      > .new {
        margin-bottom: 14px;

        > .newTag {
          margin-top: 2px;
          width: 40px;
          height: 22px;
          font-size: 16px;
          font-weight: 600;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          background: linear-gradient(#85B2FF, #6B90FF);
        }

        > .title {
          text-align: left;
        }

        > .new-width {
          width: 190px;
        }
      }

      > .goods-price-panel {
        > .hot-price-tag {
          img {
            position: relative;
            top: 4px;
            left: -2px;
            width: 21px;
            height: 21px;
          }

          .font {
            font-size: 18px;
            font-weight: 600;
            color: rgba(255, 57, 57, 1);
          }
        }

        > .hot-price {
          justify-content: space-between;
          margin: 19px 24px 46px;
          width: 197px;
          height: 42px;
          background: url('../assets/goods/specialpricegodds.png') no-repeat;
          background-size: 197px 42px;

          .goods-activity-price {
            margin-top: 4px;
            margin-left: 15px;
            font-size: 24px;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);

            span {
              font-size: 14px;
            }
          }

          .goods-original-price {
            margin-top: 10px;
            margin-right: 15px;
            font-size: 18px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
          }
        }
      }
    }
  }

  .goods-item-vgoods {
    // background: rgba(249, 249, 249, 1);
    border-radius: 2px;
    width: 285px;
    max-width: 285px;
    height: 450px;
    min-height: 450px;
    background: #FFFFFF;
    // padding-bottom: 15px;

    .goods-image {
      position: relative;
      overflow: hidden;
      margin: 0 20px 16px;
      min-width: 245px;
      max-width: 245px;
      min-height: 245px;
      max-height: 245px;
      line-height: 245px;

      > img {
        display: inline-block;
        max-width: 245px;
        max-height: 245px;
        vertical-align: middle;
      }

      .overlay-text {
        position: absolute;
        z-index: 2;
        margin: 50px 40px;
        border-radius: 50%;
        width: 180px;
        height: 180px;
        color: #FFFFFF;
        background: rgba(0, 0, 0, 1);
        opacity: .6;
        transform: rotate(-45deg);
        line-height: 180px;
        letter-spacing: 0;
      }

      .text {
        font-size: 18px;
      }

      .goods-activity-soon,
      .goods-activity-new {
        position: relative;
        top: -41px;
        justify-content: flex-end;
        padding-right: 10px;
        max-width: 245px;
        height: 41px;
        text-align: center;
        background: url('../assets/goods/newgoods.png') no-repeat;
        background-size: 245px 41px;

        > .text {
          font-size: 14px;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          line-height: 41px;

          .span {
            font-size: 14px;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
          }
        }
      }

      .goods-activity-soon {
        position: relative;
        top: -41px;
        justify-content: flex-end;
        padding-right: 10px;
        max-width: 245px;
        height: 41px;
        text-align: center;
        background: url('../assets/goods/soongoods.png') no-repeat;
        background-size: 245px 41px;
      }
    }

    .goods-content {
      position: relative;
      padding: 0 20px;
      text-align: left;

      .showbuycar {
        position: absolute;
        top: 130px;
        left: 0;
        width: 285px;
      }

      .showtopbar {
        position: absolute;
        top: -282px;
        left: 0;
        width: 285px;
      }

      > .goods-name {
        margin-bottom: 6px;

        > .newTag {
          margin-top: 2px;
          width: 40px;
          height: 22px;
          font-size: 16px;
          font-weight: 600;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          background: linear-gradient(#85B2FF, #6B90FF);
        }

        > .title {
          font-size: 18px;
          font-weight: 400;
          color: rgba(34, 34, 34, 1);
        }

        > .new-width {
          margin-left: 6px;
          width: 190px;
        }

        > .width {
          width: 240px;
        }
      }

      > .goods-size {
        margin-top: 4px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(119, 119, 119, 1);
        line-height: 20px;

        .goods-exp {
          width: 200px;
        }
      }

      > .goods-activity-label {
        overflow: hidden;
        margin-top: 5px;
        min-height: 24px;

        .tag {
          margin-right: .2rem;
          border: #FE3F3F 1px solid;
          border-radius: 2px;
          width: 36px;
          height: 20px;
          font-size: 12px;
          font-weight: 400;
          text-align: center;
          color: rgba(255, 57, 57, 1);
          background: #FFE4E5;
          line-height: 20px;
        }

        .tag:last-child {
          margin-right: 0;
        }
      }

      .goods-price-panel {
        justify-content: space-between;

        .goods-price {
          .goods-activity-price {
            font-size: 24px;
            font-weight: 800;
            color: rgba(255, 57, 57, 1);

            span {
              font-size: 14px;
              //   margin-right: 1px;
            }
          }
        }

        .goods-price-calc {
          font-size: 14px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }

        .goods-add-cart {
          border-radius: 2px;
          width: 96px;
          height: 28px;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          background: rgba(255, 57, 57, 1);
          line-height: 28px;
          cursor: pointer;
        }
      }
    }

    .goods-activity-content {
      position: relative;
      padding: 0 20px;
      text-align: center;

      .showbuycar {
        position: absolute;
        top: 130px;
        left: 0;
        width: 285px;
      }

      .showtopbar {
        position: absolute;
        top: -282px;
        left: 0;
        width: 285px;
      }

      .goods-name {
        margin-bottom: 14px;

        > .title {
          margin-left: 6px;
          font-size: 18px;
          font-weight: 400;
          text-align: center;
          color: rgba(34, 34, 34, 1);
        }

        > .width {
          width: 240px;
        }
      }

      > .new {
        margin-bottom: 14px;

        > .newTag {
          margin-top: 2px;
          width: 40px;
          height: 22px;
          font-size: 16px;
          font-weight: 600;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          background: linear-gradient(#85B2FF, #6B90FF);
        }

        > .title {
          text-align: left;
        }

        > .new-width {
          width: 190px;
        }
      }

      > .goods-price-panel {
        > .hot-price-tag {
          img {
            position: relative;
            top: 4px;
            left: -2px;
            width: 21px;
            height: 21px;
          }

          .font {
            font-size: 18px;
            font-weight: 600;
            color: rgba(255, 57, 57, 1);
          }
        }

        > .hot-price {
          justify-content: space-between;
          margin: 19px 24px 46px;
          width: 197px;
          height: 42px;
          background: url('../assets/goods/specialpricegodds.png') no-repeat;
          background-size: 197px 42px;

          .goods-activity-price {
            margin-top: 4px;
            margin-left: 15px;
            font-size: 24px;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);

            span {
              font-size: 14px;
            }
          }

          .goods-original-price {
            margin-top: 10px;
            margin-right: 15px;
            font-size: 18px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
          }
        }
      }
    }
  }

  .goods-item-sgoods {
    min-width: 285px;
    max-width: 285px;

    > .goods-image {
      position: relative;
      margin: 0 72px 4px 73px;
      min-width: 140px;
      max-width: 140px;
      min-height: 140px;
      max-height: 140px;
      line-height: 140px;

      > img {
        display: inline-block;
        max-width: 140px;
        max-height: 140px;
        vertical-align: middle;
      }

      .overlay-text {
        position: absolute;
        z-index: 2;
        margin: 5px;
        border-radius: 50%;
        width: 120px;
        height: 120px;
        color: #FFFFFF;
        background: rgba(0, 0, 0, 1);
        opacity: .6;
        transform: rotate(-45deg);
        line-height: 120px;
        letter-spacing: 0;
      }

      .text {
        font-size: 18px;
      }
    }

    > .goods-content {
      padding: 0 20px;
      text-align: center;

      .goods-name {
        margin-bottom: 4px;

        > .title {
          margin-left: 6px;
          font-size: 18px;
          font-weight: 400;
          text-align: center;
          color: rgba(34, 34, 34, 1);
        }

        > .width {
          width: 240px;
        }
      }

      > .new {
        margin-bottom: 14px;

        > .newTag {
          margin-top: 2px;
          width: 40px;
          height: 22px;
          font-size: 16px;
          font-weight: 600;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          background: linear-gradient(#85B2FF, #6B90FF);
        }

        > .title {
          text-align: left;
        }

        > .new-width {
          width: 190px;
        }
      }

      > .goods-price-panel {
        .goods-price {
          .goods-activity-price {
            font-size: 24px;
            font-weight: 800;
            color: rgba(255, 57, 57, 1);

            span {
              font-size: 14px;
            }
          }
        }
      }
    }

    > .goods-activity-content {
      padding: 0 20px;
      text-align: center;

      .goods-name {
        margin-bottom: 4px;

        > .title {
          margin-left: 6px;
          font-size: 18px;
          font-weight: 400;
          text-align: center;
          color: rgba(34, 34, 34, 1);
        }

        > .width {
          width: 240px;
        }
      }

      > .new {
        margin-bottom: 14px;

        > .newTag {
          margin-top: 2px;
          width: 40px;
          height: 22px;
          font-size: 16px;
          font-weight: 600;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          background: linear-gradient(#85B2FF, #6B90FF);
        }

        > .title {
          text-align: left;
        }

        > .new-width {
          width: 190px;
        }
      }

      > .goods-price-panel {
        > .hot-price-tag {
          img {
            position: relative;
            top: 4px;
            left: -2px;
            width: 21px;
            height: 21px;
          }

          .font {
            font-size: 18px;
            font-weight: 600;
            color: rgba(255, 57, 57, 1);
          }

          .price {
            font-size: 24px;
            font-weight: 800;
            color: rgba(255, 57, 57, 1);
          }

          span {
            font-size: 14px;
          }
        }
      }
    }
  }

  .WanShaBtn {
    padding: 0 5px;
    height: 30px;
  }

  .WanShaSpanBtn {
    padding: 5px;
    height: 30px;
    color: white;
    background: #1989FA;
    cursor: pointer;
  }
}
</style>
